import React, { Fragment, useEffect, useState } from 'react';
import Layout from 'components/sales/layout/layout';
import localization from 'assets/localization/localization';
import FormSection from 'components/sales/formSection/formSectionNew';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import TableSection from 'components/sales/tableSection/tableSection';
import useLatLng from 'hooks/uselatlng/uselatlng';
import { handleValidateObj } from 'constants/objValues/objvalues';
import { Button, FormGroup } from 'react-bootstrap';
import ModalPop from 'components/sales/modal/modal';
import Images from 'assets/images/imageData';
import GoogleMapReact from 'google-map-react';
import './attStyle.css';
import { Link } from "react-router-dom";
import ConstantInput from "../../../components/sales/Input/constantInput/constantInput";
import TextAreaInput from "../../../components/sales/Input/textAreaInput/textAreaInput";

const AttendanceDetails = ({
  getAttendanceLocationType = null,
  attendanceData = null,
  attendanceOfficeList = null,
  getAttendanceOfficeList = null,
  getAttendanceSiteList = null,
  attendanceSiteList = null,
  employeeAttendanceData = null,
  employeeCheckOutData = null,
  getProfile,
  userProfile = [],
  isJourneyStarted = false,
}) => {
  const [attendaceList, setAttendancelist] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [tableData, setTableData] = useState(null);
  const [isAttd, setIsAttd] = useState(null);
  const [locationType, setLocationType] = useState({ id: null, value: '' });
  const [locations, setLocations] = useState({ id: null, value: '' });
  const [purpose, setPurpose] = useState({ id: null, value: '' });
  const [isInOut, setIsInOut] = useState({ id: null, value: '' });
  const [mapLocation, setMapLocation] = useState({
    address: 'Delhi',
    lat: 0,
    lng: 0,
  });
  const [isFiled, setIsFiled] = useState(false);
  const [isAllow, setIsAllow] = useState(false);
  const [isAttendance, setIsAttendance] = useState(false);
  const [isLocationError, setIsLocationError] = useState(false);
  const islatlng = useLatLng();
  const headers = ['Name', 'Location Type', 'Detail', 'Type', 'Time'];

  const [modal, setModal] = useState(false);
  const [locationList, setLocationList] = useState(null);
  const [officeLocationList, setOfficeLocationList] = useState(null);
  const [remark, setRemark] = useState(' ');
  const [checkoutRemark, setCheckoutRemark] = useState(null);
  const [isCheckoutModal, setIsCheckoutModal] = useState(false);

  const activeAttendance = userProfile?.[0];
  const isCheckedIn =
    isJourneyStarted ||
    (userProfile?.length > 0 &&
      activeAttendance &&
      (activeAttendance.type_id == 1 ||
        String(activeAttendance.type || '').toLowerCase() === 'in'));

  useEffect(() => {
    if (getAttendanceLocationType) {
      getAttendanceLocationType();
    }
    if (islatlng === false) {
      setIsAllow(true);
    } else {
      setIsAllow(false);
      
    }
    var lati = Number(islatlng?.lat);
    var langi = Number(islatlng?.lng);
    if(!isNaN(lati) && !isNaN(langi)){
      setMapLocation({
        address: 'Delhi6',
        lat: Number(islatlng?.lat),
        lng: Number(islatlng?.lng),
      });
    }
    
   
  }, [islatlng]);

  useEffect(() => {
    if (attendanceData) {
      setAttendancelist(attendanceData);
    }
  }, [attendanceData]);

  useEffect(() => {
    setIsLoading(true);
    if (attendaceList?.location_type) {
      setIsLoading(false);
    }
  }, [attendaceList]);

  useEffect(() => {
    if (
      locationType?.id !== undefined &&
      locationType?.id !== null &&
      getAttendanceOfficeList !== null &&
      getAttendanceSiteList !== null &&
      islatlng !== null
    ) {
      setLocations({ id: null, value: '' });
      if (islatlng !== false) {
        setIsLocationError(false);
        if (locationType?.id === 1) {
          getAttendanceSiteList(
            locationType?.id,
            Number(islatlng?.lat) + 0.001,
            Number(islatlng?.lng) + 0.001
          );
        }
        if (locationType?.id === 2) {
          getAttendanceOfficeList(
            locationType?.id,
            Number(islatlng?.lat) + 0.001,
            Number(islatlng?.lng) + 0.001
          );
        }
        
      } else {
        setIsLocationError(true);
      }
    }
  }, [locationType, islatlng]);

  useEffect(() => {
    setLocationList([]);
    setOfficeLocationList([]);
    if (locationType?.id === 2) {
      console.log('office');
      // setLocationList(attendanceOfficeList);
      setOfficeLocationList(attendanceOfficeList);
    }
    if (locationType?.id === 1) {
      console.log('site');
      setLocationList(attendanceSiteList);
    }
    // if (attendanceSiteList !== null) {
    //   setLocationList(attendanceSiteList);
    // } else if (attendanceOfficeList !== null) {
    //   setLocationList(attendanceOfficeList);
    // }
  }, [attendanceOfficeList, attendanceSiteList]);

  useEffect(() => {
    if (
      attendaceList?.today_attendance &&
      attendaceList?.today_attendance !== undefined
    ) {
      const tablelist = attendaceList?.today_attendance;
      if (tablelist !== undefined && tablelist !== null) {
        const tableTimeupdate = tablelist.map((item) => ({
          ...item,
          time: item.time.split(' ')[1],
        }));
        if (tableTimeupdate) setTableData(tableTimeupdate);
        const inAttendance = tablelist.some(
          (el) => el.type.toLowerCase() === 'in'
        );
        const outAttendance = tablelist.some(
          (el) => el.type.toLowerCase() === 'out'
        );
        if (inAttendance && outAttendance) {
          setIsAttendance(true);
        } else {
          setIsAttendance(false);
        }
      }
    }
  }, [attendaceList]);

  const handleSubmitAttendanceData = async () => {
    if (isAllow) {
      alert(localization.locationPermission);
    }
    if (employeeAttendanceData !== null && isAllow === false) {
      
      if(remark == '' || remark == ' '){
        var data = {
          id: locations?.id !== null ? locations?.id : 0,
          lat: islatlng?.lat,
          lng: islatlng?.lng,
          type: 1,
          locations: locations?.id !== null ? locations?.id : 0,
          purpose: purpose?.id,
          locationType: locationType?.id,
        };
      }else{
        var data = {
          id: locations?.id !== null ? locations?.id : 0,
          lat: islatlng?.lat,
          lng: islatlng?.lng,
          type: 1,
          locations: locations?.id !== null ? locations?.id : 0,
          purpose: purpose?.id,
          locationType: locationType?.id,
          remark: remark,
        };
      }
      console.log(data)
      const isNotEmpty = handleValidateObj(data);
      if (isNotEmpty !== false) {
        setIsFiled(false);
        const res = await employeeAttendanceData(data);
        if (res === true) {
          setModal(true);
          getAttendanceLocationType();
          if(locationType?.id === 2){
            setIsAttd(2);
          }else{
            if(purpose?.id === 'Installation'){
              setIsAttd(1);
            }else{
              setIsAttd(4);
            }
          }
          
         await getProfile();
        }
      } else {
        setIsFiled(true);
      }
    }
  };

  // handleSubmitSkipData
  const handleSubmitCheckoutData = async () => {
    if (isAllow) {
      alert(localization.locationPermission);
      return;
    }

    let attdId = 0;
    try {
      if (typeof activeAttendance?.id !== 'undefined') {
        attdId = activeAttendance.id;
      }
    } catch (error) {
      // ...
    }

    if (employeeCheckOutData !== null && isAllow === false && attdId !== 0) {
      const data = {
        att_id: attdId,
        lat: islatlng?.lat,
        lng: islatlng?.lng,
        type: 2,
      };
      const isNotEmpty = handleValidateObj(data);
      if (isNotEmpty !== false) {
        setIsFiled(false);
        const res = await employeeCheckOutData(data);
        if (res === true) {
          setIsCheckoutModal(true);
          getAttendanceLocationType();
          await getProfile();
        }
      } else {
        setIsFiled(true);
      }
    }
  };

  const handleSubmitSkipData = async () => {
    if (isAllow) {
      alert(localization.locationPermission);
    }
    if (employeeAttendanceData !== null && isAllow === false) {
      const data = {
        // id: locations?.id,
        lat: islatlng?.lat,
        lng: islatlng?.lng,
        type: 3,
        // locations: locations?.id,
        purpose: 'Skip',
        locationType: 3,
      };
      // console.log(data); return false;
      const isNotEmpty = handleValidateObj(data);
      if (isNotEmpty !== false) {
        setIsFiled(false);
        const res = await employeeAttendanceData(data);
        if (res === true) {
          setModal(true);
          getAttendanceLocationType();
         await getProfile();
         setIsAttd(3);
        }
      } else {
        setIsFiled(true);
      }
    }
  };


  function renderMarkers(map, maps) {
    let marker = new maps.Marker({
      position: {
        lat: Number(islatlng?.lat),
        lng: Number(islatlng?.lng),
      },
      map,
      title: 'You are here!'
    });
  }
  return (
    <Layout
      className={isFiled ? 'requiredFileds' : ''}
      title={isCheckedIn ? localization.checkOut : localization.attendance}
      isLoading={isLoading}
    >

      <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.4.1/css/all.css" integrity="sha384-5sAR7xN1Nv6T6+dT2mhtzEpVJvfS3NScPQTrOxhwjIuvcA67KV2R5Jz6kr4abQsz" crossorigin="anonymous"/>
      <link href="https://fonts.googleapis.com/css?family=Roboto:300,400,500,700" rel="stylesheet"></link>
      
      <div className="main-block">
        <div className="left-part">
          <i className="fas fa-car"></i>
          <i className="fas fa-at"></i>
          <i className="fas fa-mail-bulk"></i>

        </div>
      <form className="attForm">
        {isCheckedIn ? (
          <>
            <h3>{localization.endjourney}</h3>
            <div className="info">
              <ConstantInput
                label={localization.remarks}
                type="text"
                value={checkoutRemark}
                handleChange={(val) => setCheckoutRemark(val)}
              />
            </div>
            <br />
            <Button
              onClick={handleSubmitCheckoutData}
              disabled={isLocationError}
            >
              {localization.submit}
            </Button>
          </>
        ) : (
          <>
        <h3>{localization.startjourney}</h3>
        <div className="info">
          <p style={{color:"#1c87c9"}}>Current location (Lat: {islatlng?.lat} {"\u00a0\u00a0"} Long: {islatlng?.lng})</p>
          <DropDownInput
              label={localization.locationType}
              getIdValue={(val) => {
                setLocationType({ id: val?.id, value: val?.value });
              }}
              data={attendaceList?.location_type || []}
              errorMsg={localization.requiredLocation}
              required
              isStarRequired={true}
            />
            
            {locationType?.value.length > 0 ? (
              (locationType?.id === 1 ?
            <Fragment>
              <DropDownInput
                label={'Site '+localization.location}
                getIdValue={(val) => {
                  setLocations({ id: val?.id, value: val?.value });
                }}
                data={
                  locationList && locationList.length > 0 ? locationList : []
                }
                errorMsg={localization.isRequired}
                required
                isStarRequired={true}
                value={locations?.value}
              />
            </Fragment>
            : locationType?.id === 2 ?
            <Fragment>
              {/* {console.log(officeLocationList)} */}
              {console.log('officeDD')}
              <DropDownInput
                label={'Office '+localization.location}
                getIdValue={(val) => {
                  setLocations({ id: val?.id, value: val?.value });
                }}
                data={
                  officeLocationList && officeLocationList.length > 0 ? officeLocationList : []
                }
                errorMsg={localization.isRequired}
                required
                isStarRequired={true}
                value={locations?.value}
              />
            </Fragment>
                          :""
            )
          ) : null}
          
          <DropDownInput
              label={localization.checkinPurpose}
              getIdValue={(val) => {
                setPurpose({ id: val?.id, value: val?.value });
              }}
              data={[{
                id: "Installation",
                name: "Installation",
              },
              {
                id: "Maintenance",
                name: "Maintenance",
              },
              {
                id: "Meeting",
                name: "Meeting",
              },
                {
                  id: "Other",
                  name: "Other",
                }]}
              errorMsg={localization.required}
              required
              isStarRequired={true}
            />
          {purpose?.id === "Other" &&
              <TextAreaInput
                  type="text"
                  rows={6}
                  className={`inline-css scrollbar-styling`}
                  label={localization.remark}
                  required={true}
                  isStarRequired={true}
                  errorMsg={localization.isRequired}
                  handleChange={(e) => {
                    setRemark(e.target.value)
                  }}
                  value={remark}
                  inputValue={remark}
              />
          }
        </div>
        <div className="map">
           {console.log(mapLocation)}
            <div className="google-map">
            {/* {(mapLocation &&
              <GoogleMapReact
              bootstrapURLKeys={{ key: 'AIzaSyCweWEGenU5sDidT_1MKho5VoAhMC4CgtQ' }}
              defaultCenter={mapLocation}
              defaultZoom={15}
              yesIWantToUseGoogleMapApiInternals
              onGoogleApiLoaded={({map, maps}) => renderMarkers(map, maps)}
            >
            </GoogleMapReact>
            )} */}
              
            </div>
          </div>
          <br/>
          <div className="row">
              <div className="col-6">
                <Button
                    className="btn-sm"
                    onClick={handleSubmitAttendanceData}
                    disabled={isLocationError}
                  >
                    {localization.submit}
                  </Button>
              </div>
              <div className="col-6">
              <Button
                className="btn-sm btn-danger"
                onClick={handleSubmitSkipData}
                disabled={isLocationError}
              >
                Skip
              </Button>
            </div>
        </div>
          </>
        )}
      </form>
    </div>


      <ModalPop
        title={'Check Out'}
        show={isCheckoutModal}
        handleModalHide={() => {
          setIsCheckoutModal(false);
        }}
        keyboard
        backdrop
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>Succsessfully Ended Journey</h5>
          <Link to="/dashboard/check_in" className="btn btn-primary mb-4">
            Go to {localization.startjourney}
          </Link>
        </div>
      </ModalPop>

      <ModalPop
        title={'Check In'}
        show={modal}
        // handleModalHide={() => {
        //   setModal(false);
        // }}
        keyboard
        // backdrop
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          
          
            {(isAttd && isAttd==1 ? 
                <>
                <h5>Successfully started journey (Site)</h5>
                <Link to="/dashboard/task-listing" className="btn btn-primary mb-4">Go To Task List</Link>
                </>
              :
              (isAttd && isAttd===2 ?
                <>
                <h5>Successfully started journey (Office)</h5>
                <Link to="/dashboard/site-listing" className="btn btn-primary mb-4">Go To Task List</Link>
                </>
              :
              (isAttd && isAttd===4 ?
                <>
                <h5>Successfully started journey (Site)</h5>
                <Link to="/dashboard/pm-sities" className="btn btn-primary mb-4">Go To Maintenance</Link>
                </>
              :
              <>
                <h5>Skip Check In</h5>
                <Link to="/dashboard/site-listing" className="btn btn-primary mb-4">Go To Sites</Link>
              </>
            )))}
          
        </div>
      </ModalPop>
    </Layout>
  );
};

export default AttendanceDetails;
